import React from "react";
import loadingLogo from "./img/infynito-logomotion-black.gif";

export const LoadingInfynito = (props) => {
 
  const renderMessage = () => {
  if (props.message) {
    return (
      <p>{props.message}</p>

    );
  } 
};
  return (
      <div className="d-flex flex-column py-5">
          <div className="d-flex justify-content-center">
              <img src={loadingLogo} alt="Loading..." className="loading-size" />
          </div>
      <div className="d-flex justify-content-center text-loading">
      {renderMessage()}
      </div>
    </div>
  );
};
export default LoadingInfynito;